import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';
import { isEnterPressed } from 'utils';

import './ActiveFilterSortPill.styles.scss';

type ActiveFilterSortPillProps = {
  className?: string;
  label: string;
  onRemove: () => void;
  onLabelClick?: () => void;
};

const ActiveFilterSortPill: React.FC<ActiveFilterSortPillProps> = (props) => {
  const { children, className, label, onRemove, onLabelClick } = props;

  const classes = classNames('active-filter-sort-pill', className);

  return (
    <div className={classes}>
      <span
        className="active-filter-sort-pill__label"
        {...(onLabelClick && {
          role: 'button',
          tabIndex: 0,
          onClick: onLabelClick,
          onKeyDown: (e) => isEnterPressed(e) && onLabelClick(),
        })}
      >
        {label}
      </span>

      {children}

      <Button
        className="active-filter-sort-pill__remove"
        variant="icon"
        icon={XIcon}
        onClick={onRemove}
      />
    </div>
  );
};

export default ActiveFilterSortPill;
